// Content for the Home page. Edit text here, not in components.
export const profile = {
  name: 'Timothy Gilbert',
  role: 'SOC engineer and full-stack developer',
  location: 'Jakarta, Indonesia',
  // `mark: true` segments get the highlighter.
  intro: [
    { text: 'SOC engineer and full-stack developer in Jakarta. At EY Indonesia I keep the SOC’s Splunk platform running, write ' },
    { text: 'detection use cases', mark: true },
    { text: ', and help on security incidents. I also ' },
    { text: 'build web applications end to end', mark: true },
    { text: '.' },
  ],
  description:
    'Timothy Gilbert is a SOC engineer at EY Indonesia and a full-stack developer in Jakarta. Selected projects and experience.',
  links: {
    email: 'thimoty.gilbert@gmail.com',
    github: 'https://github.com/KyloSecondBot',
    linkedin: 'https://www.linkedin.com/in/timothygilbertkylo/',
    cv: '/cv/CV.pdf',
  },
  portrait: { src: '/images/profile-800.webp', alt: 'Portrait of Timothy Gilbert' },
};
